import styled from "styled-components";
import Box from "../../containers/Box";

export const NoFavoritesWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
